var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AccountControls"},[_c('v-btn',{on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-logout")]),_vm._v(" Logout ")],1),_c('v-btn',{attrs:{"to":"/accountSettings"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-account-cog")]),_vm._v(" Account Settings ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }